import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";

export const AdModal = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="ad-modal" style={{ background: "#fafafa" }}>
        <div className="inner">
          <div className="content">
            <div style={{ fontSize: 26, textAlign: 'center', fontWeight: 700 }}>{t("solution.buildAd.features.title")}</div>
            <div className="img-bg">
              <div className="aixs-y">{t("solution.buildAd.features.axisY")}</div>
              <div className="aixs-x">{t("solution.buildAd.features.axisX")}</div>
              <img
                src="//files.authing.co/authing-website/solution-ad-axis.png"
                alt="authing ad feature"
                width="1000"
              />
            </div>
            <div className="feature-warp">
              <div className="feature-item">
                <div className="feature-content">
                  <div className="title">
                    <div className="order">01</div>
                    <div className="headline">{t("solution.buildAd.features.item1.title")}</div>
                  </div>
                  <div className="list">{t("solution.buildAd.features.item1.list1")}</div>
                  <div className="list">{t("solution.buildAd.features.item1.list2")}</div>
                  <div className="list">{t("solution.buildAd.features.item1.list3")}</div>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-content">
                  <div className="title">
                    <div className="order">02</div>
                    <div className="headline">{t("solution.buildAd.features.item2.title")}</div>
                  </div>
                  <div className="list">{t("solution.buildAd.features.item2.list1")}</div>
                  <div className="list">{t("solution.buildAd.features.item2.list2")}</div>
                  <div className="list">{t("solution.buildAd.features.item2.list3")}</div>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-content">
                  <div className="title">
                    <div className="order">03</div>
                    <div className="headline">{t("solution.buildAd.features.item3.title")}</div>
                  </div>
                  <div className="list">{t("solution.buildAd.features.item3.list1")}</div>
                  <div className="list">{t("solution.buildAd.features.item3.list2")}</div>
                  <div className="list">{t("solution.buildAd.features.item3.list3")}</div>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-content">
                  <div className="title">
                    <div className="order">04</div>
                    <div className="headline">{t("solution.buildAd.features.item4.title")}</div>
                  </div>
                  <div className="list">{t("solution.buildAd.features.item4.list1")}</div>
                  <div className="list">{t("solution.buildAd.features.item4.list2")}</div>
                  <div className="list">{t("solution.buildAd.features.item4.list3")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
